import { API_BASE_URL } from "./services";

export const fetchSubscriptionPlans = async (billingCycle = "1_month") => {
  const params = new URLSearchParams();
  if (billingCycle) params.set("billing_cycle", billingCycle);

  const response = await fetch(`${API_BASE_URL}/subscription-plans?${params.toString()}`);

  if (!response.ok) {
    throw new Error(`Unable to load subscription plans (${response.status})`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
};
